import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

const ConvertToOrder = ({ show, onClose, onConfirm }) => {
  const [installDate, setInstallDate] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState("");
  const [occupied, setOccupied] = useState("No");

  const handleConfirm = () => {
    if (!installDate) return; // install date required to become a real order
    onConfirm({ installDate, purchaseOrder, occupied: occupied === "Yes" });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Convert to Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Estimated Installation Date*</Form.Label>
          <Form.Control type="date" value={installDate} onChange={(e) => setInstallDate(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Purchase Order#</Form.Label>
          <Form.Control type="text" value={purchaseOrder} onChange={(e) => setPurchaseOrder(e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Occupied?</Form.Label>
          <Form.Select value={occupied} onChange={(e) => setOccupied(e.target.value)}>
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleConfirm} disabled={!installDate}>Convert</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConvertToOrder;
